<template>
  <div class="modal" v-bind:class="{ 'is-active': showModal }">
    <div class="modal-background" v-on:click="closeModal"></div>
    <div class="modal-content" v-if="image">
      <div class="columns is-multiline">
        <div class="column is-6" v-if="images.length == 1">
          <div class="image-actions">
            <span
              class="tag abs-tag is-warning"
              v-if="currentVisibleItemIndex >= 0"
              >{{ currentVisibleItemIndex + 1 }}/{{
                currentVisibleItems.length
              }}</span
            >

            <a :href="url" target="_blank" class="external">
              <i class="material-icons has-text-black">open_in_new</i>
            </a>
            <i
              class="material-icons starred"
              :class="{
                'has-text-black': !starred,
                'has-text-warning': starred,
              }"
              v-on:click="setStar"
              >star</i
            >

            <i class="material-icons starred" v-on:click="deleteImage"
              >delete</i
            >

            <i class="material-icons has-text-black code" v-on:click="codeView"
              >code</i
            >
            <div class="image-name">
              {{ image.name }}
            </div>
          </div>

          <gallery-image-zoom :url="url" v-if="!showPre"> </gallery-image-zoom>

          <pre v-if="showPre" class="pre"
            >{{ image }}
</pre
          >
        </div>
        <div class="column is-6" v-if="images.length > 1">
          <p>
            <span class="tag is-primary">{{ images.length }} fotos</span>
            <span
              class="tag is-info"
              style="margin-left: 0.5rem"
              v-if="selectedImages.length > 0"
            >
              {{ selectedImages.length }} seleccionadas</span
            >
            <i
              class="material-icons starred starred-inline"
              title="Marcar como destacadas"
              style="margin-left: 0.5rem"
              :class="{
                'has-text-black': !starred,
                'has-text-warning': starred,
              }"
              v-on:click="setStar"
              >star</i
            >
          </p>
          <div class="columns is-multiline">
            <div
              class="column image is-6"
              v-for="(img, i) in images"
              v-bind:key="img.id"
            >
              <!-- <a :href="urls[i].url" target="_blank" v-if="urls[i].url !== ''">
                <img v-bind:src="urls[i].url" alt="." >
              </a> -->
              <img
                v-bind:src="urls[i].url"
                alt="."
                v-on:click="selectImage(img)"
                :class="{
                  selected: selectedImages.find((s) => s.id == img.id) != null,
                }"
              />
              <span class="material-icons spin" v-if="urls[i].url === ''">
                timelapse
              </span>
            </div>
          </div>
        </div>

        <div class="column is-6">
          <div class="columns">
            <div class="column" v-if="searchListsTShirt">
              <div class="tag-cont">
                <div class="label">
                  {{ searchListsTShirt.text }}
                </div>
                <button
                  class="add-field add-value button"
                  v-bind:class="{
                    'is-light': !search.includes(
                      searchListsTShirt.code + ':' + value.code
                    ),
                    'is-primary': search.includes(
                      searchListsTShirt.code + ':' + value.code
                    ),
                  }"
                  v-for="value in searchListsTShirt.values"
                  v-bind:key="value.code"
                  v-on:click="addField(searchListsTShirt, value)"
                  :disabled="userProfile.role !== 'admin'"
                >
                  {{ value.text }}
                </button>
              </div>
            </div>
            <div
              class="column"
              v-if="searchListsOther && searchListsOther.length > 0"
            >
              <div
                class="tag-cont"
                v-for="list in searchListsOther"
                v-bind:key="list.code"
              >
                <div class="label">
                  {{ list.text }}
                </div>
                <button
                  class="add-field add-value button"
                  v-bind:class="{
                    'is-light': !search.includes(list.code + ':' + value.code),
                    'is-primary': search.includes(list.code + ':' + value.code),
                  }"
                  v-for="value in list.values"
                  v-bind:key="value.code"
                  v-on:click="addField(list, value)"
                  :disabled="updating || userProfile.role !== 'admin'"
                >
                  {{ value.text }}
                </button>
              </div>
            </div>
            <div class="column">
              <div class="label">Dorsales</div>
              <div class="add-section">
                <form v-on:submit.prevent="addNumber">
                  <input
                    type="numeric"
                    class="input"
                    placeholder="Add"
                    v-model="numberToAdd"
                    :disabled="userProfile.role !== 'admin'"
                  />
                  <button
                    type="submit"
                    class="add button is-primary"
                    :disabled="updating || userProfile.role !== 'admin'"
                  >
                    Añadir
                  </button>
                </form>
              </div>

              <div
                class="tag-cont"
                v-for="(number, i) in numbers"
                v-bind:key="i"
              >
                <span class="tag is-primary">{{ number }}</span>
                <button
                  class="delete"
                  v-if="userProfile.role === 'admin'"
                  :disabled="updating || userProfile.role !== 'admin'"
                  v-on:click="deleteNumber(number)"
                ></button>
              </div>
              <div
                class="label"
                v-if="numbersInvalid && numbersInvalid.length > 0"
              >
                Dorsales fuera de rango
              </div>
              <div class="tag-cont" v-if="numbersInvalid.length > 0">
                <span
                  v-for="(number, i) in numbersInvalid"
                  v-bind:key="i"
                  class="tag tag-invalid is-danger"
                  >{{ number }}</span
                >
              </div>

              <div class="label reviewed">Revisada</div>
              <button
                class="button"
                v-on:click="applyReviewed(!reviewed)"
                :disabled="updating || userProfile.role !== 'admin'"
                v-bind:class="{
                  'is-warning': !reviewed,
                  'is-primary': reviewed,
                }"
              >
                <i class="material-icons">{{
                  reviewed !== null && reviewed == true ? "check" : "clear"
                }}</i>
              </button>

              <button
                class="button button-close is-primary"
                v-on:click="closeModal"
                :disabled="updating"
              >
                <span v-if="!updating"> Cerrar </span>
                <span class="material-icons spin" v-if="updating">
                  timelapse
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- <button
        :disabled="updating || currentVisibleItemIndex == 0"
        class="modal-prev is-large"      
        v-on:click="navPrev"
        >
        <span class="material-icons" :class="{ 'has-text-grey': currentVisibleItemIndex == 0 }">
            keyboard_arrow_left
        </span>
      </button>
      <button
        :disabled="updating || currentVisibleItemIndex + 1 == currentVisibleItems.length"
        class="modal-next is-large"      
        v-on:click="navNext"
        >
        <span class="material-icons" :class="{ 'has-text-grey': currentVisibleItemIndex + 1 == currentVisibleItems.length }">
            keyboard_arrow_right
        </span>
      </button> -->
    </div>

    <button
      :disabled="updating || currentVisibleItemIndex == 0"
      class="modal-prev is-large modal-prev-2"
      v-on:click="navPrev"
    >
      <span
        class="material-icons"
        :class="{ 'has-text-grey': currentVisibleItemIndex == 0 }"
      >
        keyboard_arrow_left
      </span>
    </button>
    <button
      :disabled="
        updating || currentVisibleItemIndex + 1 == currentVisibleItems.length
      "
      class="modal-next is-large modal-next-2"
      v-on:click="navNext"
    >
      <span
        class="material-icons"
        :class="{
          'has-text-grey':
            currentVisibleItemIndex + 1 == currentVisibleItems.length,
        }"
      >
        keyboard_arrow_right
      </span>
    </button>

    <button
      :disabled="updating"
      class="modal-close is-large"
      aria-label="close"
      v-on:click="closeModal"
    ></button>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { EventBus } from "../services/event-bus.js";
import firebase from "firebase";
const fb = require("../firebase");
const storage = firebase.storage();
import GalleryImageZoom from "@/components/GalleryImageZoom.vue";

export default {
  props: {},
  components: {
    GalleryImageZoom,
  },
  async created() {
    EventBus.$on("image-popup", async (popupInfo) => {
      // console.log('popupInfo', popupInfo)
      //this.url = imageInfo.url;

      this.gallery = popupInfo.gallery;
      this.images = popupInfo.images;
      this.currentVisibleItems = popupInfo.currentVisibleItems;

      await this.initialize(true);

      this.showModal = true;
    });
  },
  data() {
    return {
      url: "",
      urls: [],
      image: {},
      images: [],
      reviewed: false,
      showModal: false,
      numberToAdd: "",
      numbers: [],
      numbersInvalid: [],
      showPre: false,
      gallery: {},
      search: [],
      updating: false,
      currentVisibleItems: [],
      currentVisibleItemIndex: -1,
      starred: false,
      selectedImages: [],
      showZoom: false,
    };
  },
  computed: {
    ...mapState(["userProfile"]),
    searchListsTShirt() {
      if (!this.gallery || !this.gallery.searchLists) {
        return [];
      }
      const list = this.gallery.searchLists.find(
        (l) => l.code == "color-tshirt"
      );
      return list ? list : [];
    },
    searchListsPants() {
      if (!this.gallery || !this.gallery.searchLists) {
        return [];
      }
      const list = this.gallery.searchLists.find(
        (l) => l.code == "color-pants"
      );
      return list ? list : [];
    },
    searchListsOther() {
      if (!this.gallery || !this.gallery.searchLists) {
        return [];
      }
      const list = this.gallery.searchLists.filter(
        (l) => l.code !== "color-tshirt" && l.code !== "color-pants"
      );
      return list ? list : [];
    },
  },
  // watch: {
  //   image: async function (newVal, oldVal) {
  //     // watch it
  //     //console.log('Prop changed: ', newVal, ' | was: ', oldVal)
  //   },
  // },
  methods: {
    closeModal() {
      this.showModal = false;
      this.$emit("close", {});
    },
    async initialize(reset) {
      // console.log('this.images', this.images)
      if (reset) {
        this.selectedImages = this.images;
      }
      this.showZoom = false;
      if (this.selectedImages.length == 1) {
        this.currentVisibleItemIndex = this.currentVisibleItems.findIndex(
          (i) => i.id == this.selectedImages[0].id
        );

        let popupImage = this.selectedImages[0];
        if (popupImage.reviewed == null) {
          popupImage.reviewed = false;
        }

        // to avoid prev updates
        const img = await fb.imagesCollection.doc(popupImage.id).get();
        this.image = img.data();
        this.image.id = img.id;

        if (!this.image.search) {
          this.search = [];
        } else {
          this.search = this.image.search;
        }

        this.numbers = this.image.numbers;
        this.numbersInvalid = this.image.numbersInvalid || [];
        this.starred = this.image.starred;
        this.reviewed = this.image.reviewed;

        var fileRef = await storage.ref(
          `galleries/${this.gallery.id}/${this.image.name}`
        );
        this.url = await fileRef.getDownloadURL();
      } else {
        this.currentVisibleItemIndex = -1;
        this.image = this.selectedImages[0];
        this.search = [];
        this.numbers = [];
        this.starred = false;
        this.reviewed = false;

        if (reset) {
          this.urls = this.images.map((i) => {
            return { id: i.id, url: "" };
          });
          //console.log('selectedImages', this.selectedImages)
          this.images.forEach(async (img, i) => {
            try {
              var fileRef = storage.ref(
                `galleries/${this.gallery.id}/${img.name}`
              );
              const url = await fileRef.getDownloadURL();
              this.urls[i].url = url;
            } catch (e) {
              console.error(e);
            }
          });
        }
      }
    },
    async deleteNumber(number) {
      this.updating = true;
      for (let i = 0; i < this.selectedImages.length; i++) {
        this.selectedImages[i].numbers = this.selectedImages[i].numbers.filter(
          (n) => n != number
        );
        (this.selectedImages[i].numbers_ok =
          this.selectedImages[i].numbers.length > 0),
          await this.update(this.selectedImages[i]);
      }
      this.image = this.selectedImages[0];
      this.numbers = this.numbers.filter((n) => n != number);
      this.updating = false;
      EventBus.$emit("updated-from-modal", {});
    },
    async addNumber() {
      if (this.numberToAdd !== "") {
        this.updating = true;
        for (let i = 0; i < this.selectedImages.length; i++) {
          this.selectedImages[i].numbers.push(this.numberToAdd);
          this.selectedImages[i].numbers_ok = true;
          await this.update(this.selectedImages[i]);
        }
        this.image = this.selectedImages[0];
        this.numbers.push(this.numberToAdd);
        this.numberToAdd = "";
        this.updating = false;
        EventBus.$emit("updated-from-modal", {});
      }
    },
    async update(img) {
      await fb.imagesCollection.doc(img.id).update({
        numbers: img.numbers,
        detectText: "done-ok",
        numbers_ok: img.numbers.length > 0,
        numbers_ok_sort: img.numbers.length > 0 ? "1" : "0",
      });
      //EventBus.$emit('updated-from-modal', {});
    },
    async applyReviewed(value) {
      this.updating = true;
      this.reviewed = value;
      for (let i = 0; i < this.selectedImages.length; i++) {
        await fb.imagesCollection.doc(this.selectedImages[i].id).update({
          reviewed: value,
          reviewed_sort: value ? "1" : "0",
        });
      }
      this.image.reviewed = value;
      this.updating = false;
      EventBus.$emit("updated-from-modal", {});
    },
    async addField(list, value) {
      const search = `${list.code}:${value.code}`;
      let action = "";
      this.updating = true;
      if (this.search.includes(search)) {
        this.search = this.search.filter((s) => s !== search);
        action = "remove";
      } else {
        this.search.push(`${list.code}:${value.code}`);
        action = "add";
      }

      for (let i = 0; i < this.selectedImages.length; i++) {
        let imgSearch = this.selectedImages[i].search || [];
        if (action === "add") {
          if (!imgSearch.includes(search)) {
            imgSearch.push(search);
          }
        } else {
          imgSearch = imgSearch.filter((s) => s !== search);
        }
        await fb.imagesCollection.doc(this.selectedImages[i].id).update({
          search: imgSearch,
        });
        this.images[i].search = imgSearch;
      }
      this.updating = false;
      //this.image.search = this.search;
      EventBus.$emit("updated-from-modal", {});
    },
    codeView() {
      this.showPre = !this.showPre;
    },
    async navNext() {
      if (this.currentVisibleItemIndex + 1 < this.currentVisibleItems.length) {
        this.images = [
          this.currentVisibleItems[this.currentVisibleItemIndex + 1],
        ];
        await this.initialize(true);
      }
    },
    async navPrev() {
      if (this.currentVisibleItemIndex > 0) {
        this.images = [
          this.currentVisibleItems[this.currentVisibleItemIndex - 1],
        ];
        await this.initialize(true);
      }
    },
    async setStar() {
      if (this.userProfile.role !== "admin") {
        return;
      }
      this.starred = !this.starred;
      this.updating = true;

      for (let i = 0; i < this.selectedImages.length; i++) {
        await fb.imagesCollection.doc(this.selectedImages[i].id).update({
          starred: this.starred,
        });
      }
      this.image.starred = this.starred;
      this.updating = false;
      EventBus.$emit("updated-from-modal", {});
    },
    async selectImage(img) {
      const exists = this.selectedImages.find((s) => s.id == img.id);
      if (exists) {
        if (this.selectedImages.length > 1) {
          this.selectedImages = this.selectedImages.filter(
            (i) => i.id !== img.id
          );
          await this.initialize(false);
        }
      } else {
        this.selectedImages.push(img);
        await this.initialize(false);
      }
    },
    zoom() {
      this.showZoom = !this.showZoom;
    },
    async deleteImage() {
      if (this.userProfile.role !== "admin") {
        return;
      }
      if (this.selectedImages.length > 0) {
        const result = await this.$swal({
          title: "¿Borrar?",
          text: `¿Está seguro de borrar la foto?`,
          icon: "question",
          confirmButtonText: "Sí",
          showCancelButton: true,
          cancelButtonText: "No",
        });

        if (result.value) {
          for (let i = 0; i < this.selectedImages.length; i++) {
            const galleryId = `deleted_${this.galleryId}`;
            await fb.imagesCollection.doc(this.selectedImages[i].id).update({
              galleryId: galleryId,
            });
            // console.log('this.selectedImages[i]', this.selectedImages[i])
          }

          await fb.galleriesCollection
            .doc(this.galleryId)
            .update({
              photos: firebase.firestore.FieldValue.increment(
                -1 * this.selectedImages.length
              ),
            });

          this.closeModal();
        }
      }
      // let selected = JSON.parse(JSON.stringify(this.selected));
      // selected.forEach(async (img) => {
      //   const image = this.galleryImages.find((gi) => gi.id === img.id);
      //   if (image) {
      //     // const res = await fb.imagesCollection.doc(img.id).delete();
      //     const res = await fb.imagesCollection.doc(img.id).update({ galleryId: `deleted_${this.galleryId}` });
    },
  },
};
</script>
<style scoped>
.modal-content {
  max-width: auto;
  min-width: 80vw;
}
.tag-cont {
  margin-bottom: 14px;
}
.delete {
  margin-top: 3px;
  margin-left: 8px;
}
.add-section {
  margin-bottom: 1rem;
}
.add-section .add {
  margin-top: 0.5rem;
}
.label {
  margin-top: 0.5rem;
  font-size: 0.9rem;
  width: 100%;
  text-align: center;
}
.reviewed {
  margin-top: 3rem;
}
.pre {
  font-size: 0.7rem;
  max-height: 75vh;
  margin-top: 1rem;
}
.tag-invalid {
  margin-right: 4px;
  margin-bottom: 4px;
}
.add-field {
  margin-bottom: 0.5rem;
}
.button-close {
  margin-top: 6rem;
}
.label-btn {
  color: #363636 !important;
  opacity: 1;
  font-weight: bold;
  font-size: 0.9rem;
}
.img-zoom-container {
  position: relative;
}
* {
  box-sizing: border-box;
}
.img-zoom-lens {
  position: absolute;
  border: 1px solid #d4d4d4;
  /*set the size of the lens:*/
  width: 40px;
  height: 40px;
}

.img-zoom-result {
  border: 0px solid #d4d4d4;
  margin-top: 0.5rem;
  /*set the size of the result div:*/
  width: 300px;
  height: 300px;
}
.external {
  cursor: pointer;
}
.code {
  cursor: pointer;
}
.abs-tag {
  /* position: absolute; */
}
.spin {
  -webkit-animation: spin 4s linear infinite;
  -moz-animation: spin 4s linear infinite;
  animation: spin 4s linear infinite;
}
@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}
@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.modal-prev {
  position: absolute;
  left: -6px;
  top: 0px;
}
.modal-next {
  position: absolute;
  right: -6px;
  top: 0px;
}
.modal-prev span,
.modal-next span {
  font-size: 48px;
}
.modal-prev-2 {
  left: 7.5vw;
  z-index: 1000;
  color: #999;
  position: absolute;
  top: 5rem;
}
.modal-next-2 {
  left: 89.5vw;
  z-index: 1000;
  color: #999;
  position: absolute;
  top: 5rem;
}
.modal-prev-2:hover span,
.modal-next-2:hover {
  color: #ccc;
}
.image-actions {
  display: flex;
  margin-bottom: 0.5rem;
}
.image-actions > * {
  margin-right: 1.5rem;
}
.image-name {
  color: #6c757d;
  font-size: 0.8rem;
}
.starred {
  cursor: pointer;
}
.starred-inline {
  vertical-align: -6px;
}
img.selected {
  border: 2px solid #3298dc;
}
</style>
